import React, { useEffect, useState } from "react";
import { Modal, Form, Select, Button, notification } from "antd";
import useUserStore from "../../stores/store";
import ApiService from "../../utils/ApiService";
import useScrollLock from "../../hooks/useScrollLock";

const ChangeStaffBranchModal = ({ openModal, records }) => {
  const [form] = Form.useForm();
  const [initialBranches, setInitialBranches] = useState([]);
  const { selectedItem, onFinish, onCancel } = records;
  const { branches, restaurantId, restaurantName, user, showNotification } = useUserStore();
  const [api, contextHolder] = notification.useNotification();

  // Lock scroll when modal is open
  useScrollLock(openModal);

  const openNotification = (
    type,
    message,
    description,
    placement = "topRight"
  ) => {
    api[type]({
      message,
      description,
      placement,
    });
  };

  useEffect(() => {
    if (selectedItem && Array.isArray(selectedItem.restaurants)) {
      const activeRestaurants = selectedItem.restaurants.filter(
        (restaurant) => restaurant.status === "On"
      );

      const activeRestaurantIds = activeRestaurants.map(
        (restaurant) => restaurant.restaurantId
      );

      const defaultSelectedBranches = branches
        .filter((branch) => activeRestaurantIds.includes(branch.restaurantId))
        .map((branch) => branch.restaurantId);

      form.setFieldsValue({ branches: defaultSelectedBranches });
      setInitialBranches(defaultSelectedBranches);
    }
  }, [selectedItem, branches, form]);

  const onSubmit = async (values) => {
    try {
      const payload = {
        staffId: records.selectedItem?._id,
        branchIds: values.branches,
        restaurantId,
      };

      const response = await ApiService.STAFF_BRANCH_CHANGE(
        payload,
        user.token.token
      );

      if (response.code !== 200) {
        showNotification("Failed to update staff branches");
        return;
      }

      // Check if any selected branches are not from current restaurant
      const selectedBranches = branches.filter((b) =>
        values.branches.includes(b.restaurantId)
      );
      const otherBranches = selectedBranches.filter(
        (b) => !b.name.includes(restaurantName)
      );

      if (otherBranches.length > 0) {
        showNotification(`Staff branches updated successfully.`, false);
      }

      onFinish(response);
      form.resetFields();
    } catch (error) {
      showNotification("Failed to update staff branches. Please try again.");
      console.error("Error updating staff branches:", error);
    }
  };

  const handleCancel = () => {
    form.setFieldsValue({ branches: initialBranches });
    onCancel();
  };

  return (
    <Modal
      maskClosable={false}
      title={`Change Branches for ${selectedItem?.name}`}
      open={openModal}
      onCancel={handleCancel}
      footer={null}
      centered
    >
      {contextHolder}
      <Form form={form} onFinish={onSubmit}>
        <Form.Item
          label="Select Branches"
          name="branches"
          rules={[
            { required: true, message: "Please select at least one branch!" },
          ]}
        >
          <Select mode="multiple" placeholder="Select branches" allowClear>
            {branches.map((branch, index) => (
              <Select.Option key={index} value={branch.restaurantId}>
                {branch.name} - {branch.branch}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <div className="flex justify-end">
          <Button onClick={handleCancel} className="mr-2">
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            style={{
              backgroundColor: "#FFD700",
              color: "#000000",
              fontFamily: "ubold",
            }}
          >
            Save
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ChangeStaffBranchModal;
